import { Component, Input, OnInit, inject } from '@angular/core';
import { DocService } from '../../doc.service';
import { DocsConfigItem } from '../../model/docs';
import { EverythingSearchResult } from '../../model/everything-search-result';
import { ProductNamePipe } from '../../pipe/product-name.pipe';
import { SearchResultGenericComponent } from '../search-result-generic/search-result-generic.component';

@Component({
  selector: 'app-search-result-doc',
  templateUrl: './search-result-doc.component.html',
  styleUrls: [ './search-result-doc.component.scss' ],
  imports: [ SearchResultGenericComponent, ProductNamePipe ]
})
export class SearchResultDocComponent implements OnInit {
  private docService = inject(DocService);

  @Input() result: EverythingSearchResult;
  book: DocsConfigItem;

  async ngOnInit() {
    const { productId, version, bookId } = this.result;
    if (productId && version && bookId) {
      this.book = await this.docService.getBook(productId, version, bookId);
    }
  }
}
